import { getWebviewPlatform } from '@busuu/web-view';

var OneTrustConsentService = /** @class */ (function () {
    function OneTrustConsentService() {
        var _this = this;
        this.consentChangedListeners = new Set();
        this.getActiveCookieCategories = function () {
            var _a;
            return (_a = window.OnetrustActiveGroups) === null || _a === void 0 ? void 0 : _a.split(',').filter(function (category) { return Boolean(category); });
        };
        this.sendTrackingOnConsentChange = function (trackingCallback, hasConsentedToCookies, cookies) {
            var trackingEvent = hasConsentedToCookies ? 'COOKIES_OPTED_IN' : 'COOKIES_OPTED_OUT';
            var params = { source_page: window.location.href, platform: getWebviewPlatform(), cookies: cookies };
            void trackingCallback(trackingEvent, params);
        };
        this.subscribeToCookieChange = function (trackingCallback) {
            var cookiesBeforeChangingConsent = _this.getActiveCookieCategories();
            var listener = {
                cookiesBeforeChangingConsent: cookiesBeforeChangingConsent,
                callback: _this.sendTrackingOnConsentChange,
                trackingCallback: trackingCallback,
            };
            _this.consentChangedListeners.add(listener);
            return _this.createUnsubscribeCallback(listener);
        };
        this.createUnsubscribeCallback = function (listener) {
            return function () {
                _this.consentChangedListeners.delete(listener);
            };
        };
        this.onCookieConsentChanged = function (e) {
            _this.consentChangedListeners.forEach(function (listener) {
                var _a;
                var consentedCookies = e.detail;
                var totalConsentedCookies = consentedCookies.length;
                var totalConsentedCookiesBeforeConsentChange = ((_a = listener === null || listener === void 0 ? void 0 : listener.cookiesBeforeChangingConsent) === null || _a === void 0 ? void 0 : _a.length) || 0;
                // Don't send any tracking if the cookies preferences have not been updated
                if (totalConsentedCookies === totalConsentedCookiesBeforeConsentChange)
                    return;
                var hasConsentedToCookies = totalConsentedCookies > totalConsentedCookiesBeforeConsentChange;
                listener.cookiesBeforeChangingConsent = consentedCookies;
                void listener.callback(listener.trackingCallback, hasConsentedToCookies, consentedCookies);
            });
        };
        /**
         * Gets cookie icon element and adds an event listener so when clicked
         * we check if the Manage Preferences modal is displayed. Based on this
         * we send tracking that the modal has been viewed
         *
         */
        this.onOpeningCookiePreferencesModal = function (trackingCallback) {
            var cookiePreferencesIcon = document.getElementsByClassName('ot-floating-button__open')[0];
            if (cookiePreferencesIcon) {
                cookiePreferencesIcon.addEventListener('click', function () {
                    var managePreferencesModal = document.getElementById('onetrust-pc-sdk');
                    var styles = managePreferencesModal && window.getComputedStyle(managePreferencesModal);
                    if ((styles === null || styles === void 0 ? void 0 : styles.display) === 'block')
                        trackingCallback('COOKIE_BANNER_MANAGE_PREFERENCES_VIEWED', {
                            platform: getWebviewPlatform(),
                            source_page: window.location.href,
                        });
                });
            }
        };
    }
    OneTrustConsentService.prototype.init = function (trackingCallback) {
        var _a;
        var onConsentChanged = (_a = window.OneTrust) === null || _a === void 0 ? void 0 : _a.OnConsentChanged;
        this.onOpeningCookiePreferencesModal(trackingCallback);
        if (onConsentChanged) {
            this.subscribeToCookieChange(trackingCallback);
            onConsentChanged(this.onCookieConsentChanged);
        }
    };
    return OneTrustConsentService;
}());
var OneTrustCookieConsentService = new OneTrustConsentService();

var COOKIE_BANNER_EVENTS = {
    COOKIE_BANNER_MANAGE_PREFERENCES_VIEWED: {
        name: 'busuu_web:cookie_banner_manage_preferences_viewed',
        required_params: ['platform', 'source_page'],
    },
    COOKIES_OPTED_IN: {
        name: 'busuu_web:cookie_opted_in',
        required_params: ['platform', 'source_page', 'cookies'],
    },
    COOKIES_OPTED_OUT: {
        name: 'busuu_web:cookie_opted_out',
        required_params: ['platform', 'source_page', 'cookies'],
    },
};

export { COOKIE_BANNER_EVENTS, OneTrustCookieConsentService };
//# sourceMappingURL=index.esm.js.map
